import React, { Component } from 'react';
import _ from 'lodash';
import { Form } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

class SimpleSelections extends Component {
  __cache = {};

  state = {
    ref: React.createRef(),
  };

  handleOnSelect = (value) => {
    const { name } = this.props;

    // Caché
    if (value.length > 0) {
      this.__cache[name] = value[0];
    }

    this.props.onChange({
      [name]: !!value ? value[0] : '',
    });
  };

  isRequired = (value) => {
    return value === false && this.isFieldRequired();
  };

  isFieldRequired() {
    const rules = this.props.rules || [];

    const result = rules.filter((rule) => rule === 'required');

    let isRequired = false;

    if (!_.isEmpty(result)) {
      isRequired = true;
    }

    return isRequired;
  }

  render() {
    const { ref } = this.state;
    const { name, onChange, selected, onRef, label, options = [], ...rest } = this.props;

    let selectedOption = undefined;

    if (selected) {
      selectedOption = [selected];
    } else {
      selectedOption = !!this.__cache[name] && [this.__cache[name]];
    }

    return (
      <>
        {!!label && (
          <Form.Label className={this.isRequired(selectedOption) && 'text-danger font-weight-bold'}>
            {label} {this.isFieldRequired() && <strong> * </strong>}
          </Form.Label>
        )}

        <Typeahead
          clearButton
          ref={onRef || ref}
          options={options}
          onChange={this.handleOnSelect}
          defaultSelected={selectedOption || []}
          labelKey={(option) =>
            `${option.id}, ${option.sucursal}, ${option.ciudad}, ${option.codigo_postal}, Iva fronterizo: ${option.iva_fronterizo}`
          }
          filterBy={['id', 'sucursal', 'ciudad', 'iva_fronterizo', 'codigo_postal']}
          placeholder="Selecciona una sucursal..."
          {...rest}
        />
      </>
    );
  }
}

export default SimpleSelections;
